<div
  class="employee-basket-cart-management-row"
  [style.background-color]="selectedBackgroundColor()"
>
  <div class="employee-basket-cart-management-row__info">
    <div class="employee-basket-cart-management-row__title">
      <button
        class="employee-basket-cart-management-row__name"
        type="button"
        (click)="onNameClick($event)"
      >
        {{ benefit().name | translate }}
      </button>
      @if (rejectedOfferReason(); as reason) {
        <mat-icon
          class="employee-basket-cart-management-row__reject-info"
          matTooltipClass="fo-field-info-tooltip"
          svgIcon="fo-info"
          tabindex="0"
          [attr.aria-label]="reason"
          [matTooltip]="reason"
        ></mat-icon>
      }
    </div>
    <flexyoo-employee-financing-plan-badge
      [pbGrossAmount]="pbGrossAmount()"
      [ssGrossAmount]="ssGrossAmount()"
    />
  </div>

  @if (rejectedOfferReason()) {
    <button
      class="employee-basket-cart-management-row__reupload"
      type="button"
      (click)="onReuploadClick($event)"
    >
      <mat-icon [svgIcon]="'fo-warn'"></mat-icon>
      <span>{{ 'employee.basket.reupload-document' | translate }}</span>
    </button>
  }

  @if (showPb()) {
    <div
      class="employee-basket-cart-management-row__amount"
      [class.employee-basket-cart-management-row__amount--rejected]="isRejected()"
    >
      @if (pbAmount() !== null) {
        {{ pbAmount() | flexyooNumber }}
      }
    </div>
  }
  @if (showSs()) {
    <div
      class="employee-basket-cart-management-row__amount"
      [class.employee-basket-cart-management-row__amount--rejected]="isRejected()"
    >
      {{ ssAmount() | flexyooNumber }}
    </div>
  }

  @if (showRemove() && benefit().canRemove) {
    <div class="employee-basket-cart-management-row__actions">
      <button
        class="employee-basket-cart-management-row__action employee-basket-cart-management-row__action--remove"
        type="button"
        (click)="onRemoveClick($event)"
      >
        <mat-icon svgIcon="fo-trash"></mat-icon>
      </button>
    </div>
  }
</div>
